<template>
  <!-- Modal -->
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="selectedRoom !== null">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel"> {{this.selectedRoom.name}}</h5>
          <button type="button" class="btn-close" id="close-modal" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form class="popup-form" @submit.prevent="updateRoom" >

        <div class="modal-body">
            <div class="mb-3">
              <label for="room-name" class="form-label">ოთახის სახელი</label>
              <input type="text" class="form-control" id="room-name" name="name" v-model="this.selectedRoom.name">
            </div>
            <div class="mb-3">
              <label for="warehouse-name" class="form-label">საწყობი</label>
              <v-select v-model="this.selectedRoom.warehouseId" label="name" id="warehouse-name" :options="warehouses.list">
                <template v-slot:no-options>სია ცარიელია</template>
              </v-select>
            </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close">შენახვა</button>
        </div>
        </form>

      </div>
    </div>
  </div>
</template>

<script>
import { useDropzone } from "vue3-dropzone";

export default {
  name:'RoomPopup',
  props:['lastOpened'],
  computed:{
    selectedRoom(){
      this.setWarehouseToLastOpened()
      return this.lastOpened
    },
    warehouses(){
      return this.$store.state.warehouse ? this.$store.state.warehouse.list.data : null
    },

  },
  methods:{
    roomMapImage(){
      let stateRoom = this.$store.state.warehouse.room
      //todo w
      if(stateRoom !== null){
        this.$props.lastOpened.image = stateRoom.data.room.image
        this.$store.state.warehouse.room = null
      }
      return this.lastOpened.image
    },
    setWarehouseToLastOpened(){
      if (this.warehouses && this.lastOpened != null){
        let warehouse = this.warehouses.list.filter((item) => item.id === this.lastOpened.warehouseid)
        if (warehouse.length === 1){
          this.$props.lastOpened.warehouseId = warehouse[0]
        }
        if (this.lastOpened.image !== null){
          this.progress = 100
        }
      }
    },
    removeImage(){
      this.$store.dispatch('warehouse/removeRoomPicture', this.lastOpened.id).then(
          () => {
            this.progress = 0
            this.dropBg = 'white'
            this.$store.state.warehouse.room = null
            this.$parent.lastOpened.activeRoom.image = null
            this.$parent.initMap()
          }
      )
    },
    getDropzoneBg(){
      if (this.roomMapImage() === null){
        this.dropBg = 'white'
      }else{
        this.dropBg = 'uploaded-bg'
      }
      return this.dropBg
    },
    updateRoom(){
      this.$store.dispatch('warehouse/updateRoom',{
        roomId: this.lastOpened.id,
        name:this.lastOpened.name,
        warehouseid: this.lastOpened.warehouseId.id
      }).then(
          () => {
            document.getElementById('close-modal').click()
          }
      )
    }
  },
  data(){
    const saveFiles = (files) => {
      const formData = new FormData(); // pass data as a form
      formData.append('file', files[0])
      formData.append('roomId', this.lastOpened.id)
      this.$store.dispatch('warehouse/updateRoomMapPicture', formData).then(
          ()  => {
            this.$parent.fetchSensorPins()
            this.progress = 100
            this.dropBg = 'uploaded-bg'
            this.$parent.lastOpened.activeRoom.image = this.$parent.$store.state.warehouse.tmpRoom.room.image
          }
      )
    };

    function  onDrop(acceptedFiles) {
      saveFiles(acceptedFiles);
    }

    const { getRootProps, getInputProps, ...rest } = useDropzone({onDrop});

    return {
      getRootProps,
      getInputProps,
      ...rest,
      progress:100,
      dropBg:'white'
    };
  },
}
</script>

<style scoped>

.white{
  color: #FFFFFF;
}
.uploaded-bg{
  background-color: var(--dropzone-bg);
}

.modal{
  z-index: 99999;
}

.popup-form{
  text-align: left;
}

.dropzone-holder{
  border: 1px dashed var(--dropzone-border);
  padding-top:10px;
  padding-bottom:10px;
  cursor: pointer;
  color: var(--second-titles);
}

.drop-content{
  padding: 20px 10px;
}

.image-container{
  margin-top:10px;
  padding:10px;
}

progress::-moz-progress-bar {
  background: var(--components-color);
  border-radius: 5px;
  height: 6px;
}
progress::-webkit-progress-value {
  background: var(--components-color);
  border-radius: 5px;
  height: 6px;
}
progress {
  color: var(--components-color);
  border-radius: 5px;
  height: 6px;
  transition: 1.6s;
}
progress[value]{
  height: 7px;
  transition: 1.6s;
}


</style>